import type { FC } from 'react';
import { Box } from '@interstate/components/Box';
import { NameTemplate } from '../sections/NameTemplate';
import { ConfigureVehiclesDynamic } from '../sections/ConfigureVehiclesDynamic';
import { DealScenarioSelector } from '../sections/DealScenarioSelector';
import type { UseTemplateFormState, UseTemplateFormActions } from '../hooks/useTemplateForm';

export type BaseTemplateFormProps = {
    formState: UseTemplateFormState;
    formActions: UseTemplateFormActions;
    disabled?: boolean;
    isEditing?: boolean;
};

export const BaseTemplateForm: FC<BaseTemplateFormProps> = ({ formState, formActions, disabled = false, isEditing = false }) => {
    const {
        templateName,
        templateDescription,
        templateNameConflictError,
        inventoryTypes,
        makes,
        models,
        trims,
        years,
        selectedScopeIds
    } = formState;

    const {
        setTemplateName,
        setTemplateDescription,
        setTemplateNameConflictError,
        setInventoryTypes,
        setMakes,
        setModels,
        setTrims,
        setYears,
        setSelectedScopeIds
    } = formActions;

    return (
        <>
            {!isEditing && (
                <DealScenarioSelector selectedScopeIds={selectedScopeIds} onSelectedScopeIdsChange={setSelectedScopeIds} />
            )}
            <Box mb={3}>
                <NameTemplate
                    templateDescription={templateDescription}
                    templateName={templateName}
                    setTemplateDescription={setTemplateDescription}
                    setTemplateName={setTemplateName}
                    templateNameConflictError={templateNameConflictError}
                    setTemplateNameConflictError={setTemplateNameConflictError}
                />
            </Box>
            <Box mb={12}>
                <ConfigureVehiclesDynamic
                    disabled={disabled}
                    inventoryTypes={inventoryTypes}
                    setInventoryTypes={setInventoryTypes}
                    makes={makes}
                    setMakes={setMakes}
                    models={models}
                    setModels={setModels}
                    trims={trims}
                    setTrims={setTrims}
                    years={years}
                    setYears={setYears}
                />
            </Box>
        </>
    );
};
